import React, {useEffect, useState} from "react";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import AttendanceService from "../../../../services/dispatch/attendance-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import {formatCaseCard} from "../utils/dashboard-formatters.js";

const getErrorMessage = (error, fallback) => {
    const message = error.response?.data?.errorMessages ?? error.response?.data?.message;
    if (Array.isArray(message)) return message.join("<br />");
    return message || fallback;
};

const AttendanceConvertTaskModal = ({payload, onClose, onSuccess}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const open = Boolean(payload);
    const attendance = payload?.attendance ?? payload?.item ?? payload;

    useEffect(() => {
        if (!open) return;
        setIsSubmitting(false);
    }, [open]);

    const handleSubmit = async () => {
        if (!attendance?.attendanceId) {
            projectUtils.swalErrorMessage("Erro", "Não foi possível identificar o atendimento.", "Ok");
            return;
        }

        setIsSubmitting(true);

        try {
            await AttendanceService.convertAttendanceToTask(attendance.attendanceId);
            onSuccess();
            projectUtils.swalSuccessMessage("success", "Sucesso", "Atendimento convertido em tarefa com sucesso.", "Ok");
        } catch (error) {
            console.error("Erro ao converter atendimento em tarefa pelo dashboard:", error);
            projectUtils.swalErrorMessage("", getErrorMessage(error, "Não foi possível converter o atendimento."), "Ok");
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} setOpen={onClose} title="Converter atendimento em tarefa" className="w-full max-w-2xl" isCloseClick={false}>
            <Modal.Body className="max-h-[calc(100vh-180px)] flex flex-col gap-4 overflow-auto">
                <div>
                    <p className="text-[14px] font-bold text-[#676a6c]">Atendimento</p>
                    <div className="flex flex-col text-sm text-[#555]">
                        <span>{attendance?.natureText ?? attendance?.nature}</span>
                        {attendance?.place ? <span>{formatCaseCard(attendance.place)}</span> : null}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" target="primary" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AttendanceConvertTaskModal;
